export default __webpack_public_path__ + "static/media/rosas.976ee060.jpg";